import { render } from "./AsientoDet.vue?vue&type=template&id=e5da9e70&scoped=true"
import script from "./AsientoDet.vue?vue&type=script&lang=js"
export * from "./AsientoDet.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=e5da9e70&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5da9e70"]])

export default __exports__